<template>
  <div>
    <div
      class="
        banner
        d-flex
        flex-column
        justify-content-md-center
        align-items-center
      "
      style="background-color: #1041a5"
    >
      <h1 class="mt-5 font-weight-light display-4">
        {{ this.JobDesp.JobPositionName }}
      </h1>
      <div>
        <span><i class="fas fa-building"></i> CSI Group</span>
      </div>
    </div>

    <!-- -------------------------------------------------------- -->

    <div class="container mt-4 mb-5 px-xl-5">
      <!-- <div>
        <a href="/cclick" style="color: #1041a5"> Job Openings </a>
        <i
          class="fa fa-chevron-right text-secondary"
          style="font-size: 12px"
        ></i>
        <a href="/cclick/job/QX96RV9R" style="color: #1041a5">
          RPA Developer - MTA
        </a>
        <i
          class="fa fa-chevron-right text-secondary"
          style="font-size: 12px"
        ></i>
        <span class="text-secondary">Refer someone</span>
      </div> -->

      <span v-for="(matched, idx) in this.$router.options.routes" :key="idx">
        <router-link
          v-if="idx === 0"
          :to="{ name: 'home' }"
          style="color: #1041a5; text-decoration: none"
        >
          Job Openings
        </router-link>

        <router-link
          v-if="idx === 1 && Object.keys(this.$route.params).length != 0"
          :to="{ name: 'jobview', params: { id: getJobPositionId } }"
          style="color: #1041a5; text-decoration: none"
        >
          {{ JobDesp.JobPositionName }}
        </router-link>

        <span v-if="idx === 2" class="text-secondary"> Refer someone </span>
        <span v-if="idx < 2"> > </span>
      </span>

      <form @submit.prevent="handleSubmitForm" class="was-validated">
        <div class="form-group">
          <h3>Your details</h3>
          <div css-clas="form-row" class="form-row">
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_referrer_full_name" class="form-group">
                <label for="id_referrer_full_name" class="requiredField">
                  Your Full Name: <span class="asteriskField">*</span></label
                >
                <div>
                  <input
                    type="text"
                    required="required"
                    class="textinput textInput form-control"
                    v-model="ApplyRefData.FullName"
                  />
                  <div class="invalid-feedback">This field is required.</div>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_referrer_email" class="form-group">
                <label for="id_referrer_email" class="requiredField">
                  Your Email Address:
                  <span class="asteriskField">*</span></label
                >
                <div>
                  <input
                    type="email"
                    required="required"
                    class="emailinput form-control"
                    v-model="ApplyRefData.Email"
                  />
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">This field is required.</div>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_referrer_employee_reference" class="form-group">
                <label for="id_referrer_employee_reference">
                  Your Employee ID:
                </label>
                <div>
                  <input
                    type="text"
                    class="textinput textInput form-control"
                    v-model="ApplyRefData.EmpId"
                  />
                </div>
              </div>
            </div>
          </div>
          <h3>Candidate details</h3>
          <div css-clas="form-row" class="form-row">
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_full_name" class="form-group">
                <label for="id_full_name" class="requiredField">
                  Candidate Full Name:
                  <span class="asteriskField">*</span></label
                >
                <div>
                  <input
                    type="text"
                    maxlength="255"
                    required="required"
                    class="textinput textInput form-control"
                    v-model="ApplyRefData.CandFullName"
                  />
                  <small id="hint_id_full_name" class="form-text text-muted"
                    >Full name of the candidate</small
                  >
                  <div class="invalid-feedback">This field is required.</div>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_email" class="form-group">
                <label for="id_email" class="requiredField">
                  Candidate Email Address:
                  <span class="asteriskField">*</span></label
                >
                <div>
                  <input
                    type="email"
                    required="required"
                    class="emailinput form-control"
                    v-model="ApplyRefData.CandEmail"
                  />
                  <div class="valid-feedback">Valid.</div>
                  <div class="invalid-feedback">This field is required.</div>
                </div>
              </div>
            </div>
            <div class="form-group col-md-6 mb-0">
              <div id="div_id_phone_number" class="form-group">
                <label for="id_phone_number" class="requiredField">
                  Candidate Phone Number:
                  <span class="asteriskField">*</span></label
                >
                <div>
                  <input
                    type="text"
                    maxlength="255"
                    required="required"
                    class="textinput textInput form-control"
                    v-model="ApplyRefData.CandPhone"
                  />
                  <small id="hint_id_phone_number" class="form-text text-muted"
                    >Candidate phone number</small
                  >
                  <div class="invalid-feedback">This field is required.</div>
                </div>
              </div>
            </div>
          </div>
          <div id="div_id_description" class="form-group">
            <label for="id_description"> Candidate description: </label>
            <div>
              <textarea
                cols="40"
                rows="10"
                class="textarea form-control"
                v-model="ApplyRefData.CandDesp"
              ></textarea>
              <small id="hint_id_description" class="form-text text-muted"
                >Description of the candidate - can only input text here.</small
              >
            </div>
          </div>
          <div class="form-group">
            <label for="">Resume: <span>*</span></label>
            <div class="custom-file" style="display: block; height: auto">
              <div class="mb-5">
                <input
                  class="form-control"
                  type="file"
                  @change="imageUpload"
                  required
                />
                <div class="invalid-feedback">Resume field is required.</div>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 20px">
            <input
              type="checkbox"
              name="terms_and_condition"
              value="checked"
              required
            />
            <span style="font-size: 13px">
              I agree to the
              <a href="/cclick/terms-and-conditions-referral" target="_blank">
                terms and conditions
              </a>
              &amp;
              <a href="/cclick/privacy-policy" target="_blank">
                privacy policy
              </a></span
            >
            <br />
            <div class="invalid-feedback">This field is required.</div>
          </div>
          <br />
          <!---->
          <div>
            <button
              type="submit"
              name="submit"
              id="submit-id-submit"
              class="btn btn-primary btn btn-success btn-lg btn-apply"
            >
              Apply
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import variables from "@/variables";

export default {
  data() {
    return {
      JobDesp: [],
      ApplyRefData: {
        FullName: "",
        Email: "",
        EmpId: "",
        CandFullName: "",
        CandEmail: "",
        CandPhone: "",
        CandDesp: "",
        ResumeFile: "",
        RefJobKeyId: this.$route.params.id,
      },
    };
  },
  methods: {
    handleSubmitForm() {
      console.log(variables.API_URL);

      var formData = new FormData();
      for (var key in this.ApplyRefData) {
        formData.append(key, this.ApplyRefData[key]);
      }

      console.log(formData);
      axios
        .post(variables.API_URL + "position/ApplyRefJobPosition", formData)
        .then(() => {
          this.$router.push("/");
          this.ApplyRefData = {
            FullName: "",
            Email: "",
            EmpId: "",
            CandFullName: "",
            CandEmail: "",
            CandPhone: "",
            CandDesp: "",
            ResumeFile: "",
            RefJobKeyId: "",
          };

          alert("Successfully");
        })
        .catch((error) => {
          console.log(error);
        });
    },

    imageUpload(e) {
      this.ApplyRefData.ResumeFile = e.target.files[0];
    },
  },
  created() {
    console.log(this.$route.params.id);

    axios
      .get(
        variables.API_URL +
          "position/GetViewJobDescription/" +
          this.$route.params.id
      )
      .then((response) => {
        this.JobDesp = response.data[0];

        document.title = this.JobDesp.JobPositionName + " CSI-GROUPS Open Position"
      })
      .catch((error) => {
        console.log(error);
      });
  },
  computed: {
    getJobPositionId() {
      return this.$route.params.id;
    },
    routes() {
      return this.$router.options.routes;
    },
  },
};
</script>

<style scoped>
.form-row {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
.col,
.col-1,
.col-10,
.col-11,
.col-12,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-bottom: 0;
}

@media (min-width: 768px) {
  .col-md-6 {
    -ms-flex: 0 0 50%;
    flex: 0 0 50%;
    max-width: 50%;
  }
}
</style>